import { TruncateString } from '../../../Public/Functions/TruncateString';
import { ButtonsTransaction } from '../../Form/Buttons/ButtonsTransaction';

export const Outlinks = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="name">name</div>
                    <div className="item">link</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                let name = TruncateString(el.name, 30);
                return (
                    <div key={`i-${i}`} className="rows">
                        <div className="block-rows">
                            <div className="id">{i + 1}</div>
                            <div className="name">{name}<span className="id">({el.id})</span></div>
                            <div className="item">{el.link}</div>
                        </div>
                        <ButtonsTransaction id={el.id} entity={entity} />
                    </div>
                )
            })}
        </div>
    )
} 